import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useApiServices } from '../../services/api-endpoints/useApiServices';
import { useBreadcrumb } from '../../services/breadcrumb-services/BreadcrumbContext';
import ImageViewer from '../../components/image-viewer/ImageViewer';
import { DateTimeFormat } from '../../helper/Formatters';
import AccountsBox from '../../components/accounts-box';
import CommentsBox from '../../components/comments-box';
import AddressesBox from '../../components/addresses-box';
import RecentTransactionsBox from '../../components/recent-transactions-box';
import ChatWidget from '../../components/chat/ChatWidget';

const UsersDetails = () => {
    const { id } = useParams();
    const api = useApiServices();
    const { setCustomName } = useBreadcrumb();
    const [data, setData] = useState({});
    const [transactions, setTransactions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);

    const fetch = async (id) => {
        const { isSuccess, result } = await api.GetUserByIdAsync(id);
        if (isSuccess && result) {
            setData(result);
            setCustomName(`${result.firstName} ${result.lastName}`);

            const transactionsResponse = await api.GetUsersRecentTransactionsAsync(id);
            if (transactionsResponse.isSuccess) {
                setTransactions(transactionsResponse.result);
            }
        }
    };

    useEffect(() => {
        if (id) fetch(id);
    }, [id]);

    const handleChatOpen = (userId) => {
        if (selectedUser) {
            setSelectedUser(null); // Close any existing chat first
            setTimeout(() => setSelectedUser(userId), 0); // Open the new chat after closing
        } else {
            setSelectedUser(userId);
        }
    };

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-4">
                    <div className="widget white-bg friends-group clearfix">
                        <div className="padding-20 text-center">
                            <ImageViewer id={data.image} className={"rounded-circle mar-btm margin-b-10 circle-border "}></ImageViewer>
                            <p className="lead font-500 margin-b-0 text-overflow-wrap">{`${data.firstName} ${data.lastName}`}</p>
                            <p className="text-muted">{data.userType?.name || '-'}</p>
                        </div>
                        <div style={{ display: 'flex', gap: 8, padding: '0 16px 12px', justifyContent: 'center' }}>
                            <button
                                onClick={() => handleChatOpen(data.id)}
                                style={{
                                    flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                                    padding: '7px 0',
                                    background: 'linear-gradient(135deg, #1e3a5f, #2d6a9f)',
                                    border: 'none', borderRadius: 8,
                                    color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                                    boxShadow: '0 2px 6px rgba(30,58,95,0.2)',
                                }}
                            >
                                <i className="fa fa-comment" style={{ fontSize: 12 }} />แชท
                            </button>
                            <Link
                                to="/app-chat"
                                style={{
                                    flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                                    padding: '7px 0',
                                    background: '#f3f4f6',
                                    border: '1px solid #e5e7eb', borderRadius: 8,
                                    color: '#374151', fontSize: 13, fontWeight: 600, textDecoration: 'none',
                                }}
                            >
                                <i className="fas fa-expand-alt" style={{ fontSize: 11 }} />เต็มจอ
                            </Link>
                        </div>
                        <div className="text-muted small mt-2 mt-sm-0">
                            <strong>เป็นสมาชิกเมื่อ:</strong> {DateTimeFormat(data.createDate)}
                        </div>
                    </div>
                    <div className="widget white-bg friends-group clearfix">
                        <RecentTransactionsBox data={transactions} />
                    </div>
                </div>
                <div className="col-8">
                    <div className="widget white-bg friends-group clearfix">
                        <AccountsBox euid={data.entityUniqueIdentifierId} />
                    </div>
                    <div className="widget white-bg friends-group clearfix">
                        <AddressesBox euid={data.entityUniqueIdentifierId} userId={data.id} defaultName={`${data.firstName ?? ''} ${data.lastName ?? ''}`} defaultPhone={data.phone} />
                    </div>
                    <div className="widget white-bg friends-group clearfix">
                        <CommentsBox euid={data.entityUniqueIdentifierId} />
                    </div>
                </div>
            </div>
            <ChatWidget
                isOpen={selectedUser != null}
                onToggle={() => setSelectedUser(null)}
                selectedUserId={selectedUser}
                className={`chat-widget sidebar-open`}
                style={{ right: `${selectedUser ? 300 : 0}px` }} // Adjust position for multiple widgets
            />
        </React.Fragment>
    );
};

export default UsersDetails;